import React, { useState, useEffect } from 'react';
import './Dashboard.css';

function Dashboard() {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await fetch(process.env.REACT_APP_API_URL+'/api/dashboard', {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (response.ok) {
          const data = await response.json();
          // Handle new response format
          if (data.status && data.data) {
            setUserData(data.data);
          } else {
            // Fallback for old format
            setUserData(data);
          }
        } else {
          // Handle unauthorized access
          window.location.href = '/login';
        }
      } catch (error) {
        console.error('Error fetching dashboard data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!userData) {
    return <div>Please log in to view your dashboard</div>;
  }

  return (
    <div className="dashboard">
      <div className="container">
        <h1>Dashboard</h1>
        <div className="dashboard-content">
          <div className="dashboard-card">
            <h2>Account Information</h2>
            <p><strong>Email:</strong> {userData.email}</p>
            <p><strong>Plan Type:</strong> {userData.plan_type === 1 ? 'Self Employed' : 'Teams'}</p>
            <p><strong>Billing Cycle:</strong> {userData.duration_type === 1 ? 'Monthly' : 'Yearly'}</p>
            {userData.plan_type === 2 && (
              <p><strong>Number of Workers:</strong> {userData.number_of_workers}</p>
            )}
          </div>

          <div className="dashboard-card">
            <h2>Features</h2>
            <ul className="features-list">
              {JSON.parse(userData.features).map((feature, index) => (
                <li key={index}>{feature}</li>
              ))}
            </ul>
          </div>

          <div className="dashboard-card">
            <h2>Quick Actions</h2>
            <div className="quick-actions">
              <button className="action-button">Track Mileage</button>
              <button className="action-button">Log Hours</button>
              <button className="action-button">Generate Invoice</button>
              {userData.plan_type === 2 && (
                <button className="action-button">Manage Team</button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard; 